/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useMediaQuery, Grid, Box, useTheme, Typography, Button } from "@mui/material";
import CustomRightImage from "@components/CustomRightImagev2";
import CreditOfferCard from "@components/CreditOfferCard";
import { RootState } from "@store/store";
import { useDispatch, useSelector } from "react-redux";
import { ApiError } from "@interfaces/index";
import { setModalErrorVisible } from "@store/slices/appSlice";
import * as Sentry from "@sentry/react";
import { useLazyGetOffersQuery } from "@api/marketPlaceApis";
import { setSelectedOffer } from "@store/slices/marketPlaceSlice";
import { LoanApplicationOfferResponse } from "@interfaces/MarketPlace";

const OfertaSeleccionadaCompany: React.FC = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const company = useSelector((state: RootState) => state.register.company);
  const offer = useSelector((state: RootState) => state.marketPalce.offers);
  const application = useSelector((state: RootState) => state.register.application);
  const accountUser = useSelector((state: RootState) => state.register.account_user);

  const [getOffersMarket] = useLazyGetOffersQuery();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [offerSelected, setOfferSelected] = useState<LoanApplicationOfferResponse | null>(null);
  const [hasOffer, setHasOffer] = useState<boolean>(false);

  const handleSelectedOffer = async () => {
    const rawUrl = offerSelected?.financial_company.company?.url_site;
    if (!rawUrl) {
      dispatch(
        setModalErrorVisible({
          open: true,
          error: {
            message: "No se encontró la URL de redirección para la financiera.",
          } as ApiError,
        }),
      );
      return;
    }

    const urlPortal = `${rawUrl}/producto/creditosimple/crear_cuenta_nueva?email=${accountUser.email}&company=${offerSelected.financial_company.name}&userName=${company.name}`;
    window.open(urlPortal, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const responseOffers = await getOffersMarket({ id_sol: application.id }).unwrap();

        const selected: LoanApplicationOfferResponse[] = responseOffers.filter((of) => of?.accept);
        if (selected.length > 0) {
          setOfferSelected(selected[0]);
          dispatch(setSelectedOffer(selected[0]));
          setHasOffer(true);
        } else {
          setHasOffer(false);
        }
      } catch (error) {
        const api_error = error as ApiError;
        Sentry.captureException(error, {
          extra: {
            component: "SolicitudCreditoPart1-initial_fetch",
          },
        });
        dispatch(setModalErrorVisible({ open: true, error: api_error }));
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={4}>
        <Typography
          sx={{ mb: 1 }}
          variant={isMobileOrTablet ? "h4" : "h3"}
          fontWeight={600}
          color={theme?.palette?.primary?.main}
          textAlign={"center"}
        >
          ¡Tenemos buenas noticias! <br />
          {company.name}
        </Typography>

        <Box mr={3} ml={3}>
          <Typography
            sx={{ mb: 2 }}
            variant={"body1"}
            fontWeight={300}
            color={theme?.palette?.primary?.dark}
            textAlign={"center"}
          >
            Esta oferta se completará a través del flujo digital de{" "}
            <span style={{ fontWeight: 600 }}>{offer?.financial_company?.name || "la financiera"}</span>, <br />
            operado en la plataforma de Lendia - PyMio.
          </Typography>

          <Typography
            sx={{ mb: 3, mx: 4 }}
            variant={"body1"}
            fontWeight={300}
            color={theme?.palette?.primary?.dark}
            textAlign={"center"}
          >
            Al continuar,{" "}
            <span style={{ fontWeight: 600 }}>serás redirigido para finalizar tu proceso de forma rápida y segura</span>
            , con el mismo equipo y acompañamiento que te ha atendido hasta ahora.
          </Typography>
        </Box>

        <Box
          mt={6}
          sx={{
            boxShadow: "8px 4px 20px 0px #58585840",
            borderRadius: 10,
            p: "10px 0", // paddingTop y paddingBottom juntos
            maxWidth: 500,
            margin: "0 auto", // centra horizontalmente
            display: "flex",
            justifyContent: "center",
          }}
        >
          {hasOffer ? (
            <>
              <CreditOfferCard key={offer?.id} offer={offer} offers_length={0} showButton={false} />
            </>
          ) : (
            <Typography variant="body1">No se encontró una oferta seleccionada.</Typography>
          )}
        </Box>
        <Box display="flex" justifyContent="center" mt={isMobileOrTablet ? 2 : 4} mb={1}>
          <Button variant="default" onClick={handleSelectedOffer} sx={{ width: "130px" }} disabled={isLoading}>
            Continuar
          </Button>
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default OfertaSeleccionadaCompany;
